import { toRem, toRems } from 'helpers/theme'

/* eslint-disable quote-props */
const style = ({ theme, image }) => ({
    margin: toRem(20),

    '& .ManagePromoContainer': {
        maxWidth: 1440,
        margin: 'auto',
        background: theme.colors.blueLight,
        padding: toRem(20),
        borderRadius: 4,
        overflow: 'hidden',
        [theme.breakpoints.up('md')]: {
            display: 'flex',
            padding: 0
        },
        '& .Image': {
            overflow: 'hidden',
            height: 260,
            width: '100%',
            background: `url(${image}) no-repeat center top`,
            backgroundSize: 'cover',
            borderRadius: 4,

            [theme.breakpoints.up(480)]: {
                height: 300
            },

            [theme.breakpoints.up('md')]: {
                height: 'auto',
                width: '40%',
                maxWidth: 720,
                padding: 0,
                borderRadius: 0
            }
        },

        '& .Content': {
            [theme.breakpoints.up('md')]: {
                padding: '70px 80px',
                width: '60%'
            },

            '& .Title': {
                color: theme.colors.goldDark,
                fontSize: toRem(20),

                [theme.breakpoints.up('lg')]: {
                    fontSize: toRem(24),
                    fontWeight: '500'
                }
            },

            '& .Subtitle': {
                fontSize: toRem(14),
                marginBottom: toRem(40),
                [theme.breakpoints.up('md')]: {
                    fontSize: toRem(20)
                }
            },

            '& .Text': {
                fontSize: toRem(14),
                marginBottom: toRem(30),

                [theme.breakpoints.up('md')]: {
                    maxWidth: 560
                },

                [theme.breakpoints.up('lg')]: {
                    fontSize: toRem(20),
                    marginBottom: toRem(175)
                }
            },

            '& .ButtonDesktop': {
                display: 'none',
                [theme.breakpoints.up('md')]: {
                    display: 'block'
                }
            }
        },

        '& .ButtonMobile': {
            display: 'block',
            textAlign: 'center',
            marginTop: toRem(40),
            marginBottom: toRem(20),

            [theme.breakpoints.up('md')]: {
                display: 'none'
            }
        }
    }
})

export default style
